import createLeftComponent from "../../../../helpers/common/CoreInputText/components/Left/fabric";
import { INPUT_TEXTAREA_DISPLAY_NAME } from "../../utils/core";

export const Component = createLeftComponent(INPUT_TEXTAREA_DISPLAY_NAME);
export default Component;
